export default __webpack_public_path__ + "static/media/playmateIcon.87bd9905.png";